import { ERROR_MESSAGES } from '../constants/error-messages';
import axios, { AxiosError } from 'axios';
import { getSession, signOut } from 'next-auth/react';

export async function handleLogout({ toast }: any) {
    const session = await getSession();
    // const token = session?.user?.accessToken;
    const refreshToken = session?.user?.refreshToken; 
    try {
        const response = await axios.post(`${process.env.NEXT_PUBLIC_BACKEND_API_URL}/api/iam/logout`, 
        {
            refreshToken: refreshToken, // Pass refresh token in body
        }
        );
        console.log("logout response", response);

        if (response?.data?.statusCode === 200) {
            await signOut({ callbackUrl: '/auth/login' });
        } else {
            toast?.current?.show({
                severity: 'error',
                summary: ERROR_MESSAGES.LOGOUT_FAILED,
                detail: `${response?.data?.data?.status}`,
                life: 3000,
            });
        }
    } catch (error) {
        const err = error as any;
        const message =
            err.response?.data?.data?.message || err.message || ERROR_MESSAGES.LOGOUT_FAILED;

        toast?.current?.show({
            severity: 'error',
            summary: ERROR_MESSAGES.LOGOUT_FAILED,
            detail: message,
            life: 3000,
        });
    }
}